export const experiences = [
	{
		role: 'Frontend Developer',
		company: 'Xeggo',
		startEnd: 'November 2021 - June 2023',
		workType: 'Remote',
		descriptions: [
			'User Interface Design: Built, implemented, and maintained many user interfaces according to design specifications using React, TailwindCSS and plain CSS.',
			'Interact with smart contract and connect to ethereum nodes using web3.js or ether.js',
			'Integration of third-party APIs in the new and existing web application.',
			'Built reusable components.',
			'Collaborated with the designer to talk about the UI/UX flow.',
			'Collaborated with the backend to talk about the APIs.',
			'Participated in code reviews, shared knowledge, and identify areas for improvement.',
			'Tested, debugged frontend code to identify and fix issues.',
		],
		id: 0,
	},
	{
		role: 'Frontend Developer',
		company: '247Concise Technologies',
		startEnd: 'August 2020 - September 2021',
		workType: 'Onsite',
		descriptions: [
			'Used React to convert UI designs to code and implement Business logic.',
			'Participated in code reviews, shared knowledge, and identify areas for improvement.',
			'Made the new and existing web applications to be accessible in all platforms.',
			'Integration of third-party APIs in the new and existing web application.',
			'Built reusable components.',
		],
		id: 1,
	},
	{
		role: 'Internship',
		company: 'Spurbuddy',
		startEnd: 'May - July 2020',
		workType: 'Remote',
		descriptions: [
			'Conversion of UI designs to code using React and Making an AJAX calls.',
			"Styled and made the web to be responsive depending on the user's device screen size using plain CSS.",
		],
		id: 2,
	},
	{
		role: 'Internship',
		company: 'Google Africa Developers Scholarship',
		startEnd: 'May 2019',
		workType: 'Remote',
		descriptions: [
			'Learned the fundamentals of web development',
			'Learned Programming fundamentals.',
			'Learned new more technologies.',
			'Used what I learned to build up some projects.',
		],
		id: 3,
	},
];
